import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Fiskaly } from "@data-types";
import { DateTime } from "luxon";

import FiskalySection from "./FiskalySection";

export const FiscalizationSection = observer(
	function MetaDataFiscalization(props: {
		metadata: FiscalizationMetaData | Fiskaly | null;
		currency?: string;
	}) {
		const { t } = useTranslation("mybets");

		if (props.metadata == null) {
			return null;
		}

		if ("fiskalyReceiptNumber" in props.metadata) {
			return (
				<FiskalySection
					metadata={props.metadata}
					currency={props.currency}
				/>
			);
		}

		if (
			props.metadata?.fiscalizationItems == null ||
			props.metadata.fiscalizationItems.length < 0
		) {
			return null;
		}

		const firstFinishedTransaction = props.metadata.fiscalizationItems.find(
			(i: any) => i.isFinishTransaction == true
		);

		if (!firstFinishedTransaction) {
			return null;
		}

		return (
			<>
				<tr className="table--bets__tr table--bets__fiscalization table--bets__fiscalization--dashed">
					<td className="table--bets__tf" colSpan={2}>
						<span className="u-mar--right--xtny">
							{t("mybets:ITEM.ADDITIONAL_START_TIME")}:
						</span>
						<span>
							{DateTime.fromISO(
								firstFinishedTransaction.transactionTimestamp
							).toLocaleString(DateTime.DATETIME_SHORT)}
						</span>
					</td>
				</tr>
				<tr className="table--bets__tr table--bets__fiscalization">
					<td className="table--bets__tf" colSpan={2}>
						<span className="u-mar--right--xtny">
							{t("mybets:ITEM.ADDITIONAL_END_TIME")}:
						</span>
						<span>
							{DateTime.fromISO(
								firstFinishedTransaction.transactionTimestamp
							).toLocaleString(DateTime.DATETIME_SHORT)}
						</span>
					</td>
				</tr>
				<tr className="table--bets__tr table--bets__fiscalization">
					<td className="table--bets__tf" colSpan={2}>
						<span className="u-mar--right--xtny">
							{t("mybets:ITEM.ADDITIONAL_TRANSACTION_NUMBER")}:
						</span>
						<span>
							{firstFinishedTransaction.transactionNumber}
						</span>
					</td>
				</tr>
				<tr className="table--bets__tr table--bets__fiscalization">
					<td className="table--bets__tf" colSpan={2}>
						<span className="u-mar--right--xtny">
							{t("mybets:ITEM.ADDITIONAL_SIGNATURE_COUNTER")}:
						</span>
						<span>{firstFinishedTransaction.signatureCounter}</span>
					</td>
				</tr>
				<tr className="table--bets__tr table--bets__fiscalization">
					<td className="table--bets__tf" colSpan={2}>
						<span className="u-mar--right--xtny">
							{t("mybets:ITEM.ADDITIONAL_TSE_SERIAL_NUMBER")}:
						</span>
						<span>{props.metadata.deviceSerialNumber}</span>
					</td>
				</tr>
				<tr className="table--bets__tr table--bets__fiscalization">
					<td className="table--bets__tf" colSpan={2}>
						<span className="u-mar--right--xtny">
							{t("mybets:ITEM.ADDITIONAL_SIGNATURE")}:
						</span>
						<span>{firstFinishedTransaction.signature}</span>
					</td>
				</tr>
			</>
		);
	}
);

export type FiscalizationMetaData = {
	dateCreated: Date;
	deviceSerialNumber: string;
	externalId: string;
	fiscalizationItems: FiscalizationItem[];
	processType: number;
	referenceId: string;
	status: number;
};

export type FiscalizationItem = {
	isFinishTransaction: boolean;
	signature: string;
	signatureCounter: number;
	status: number;
	transactionNumber: number;
	transactionTimestamp: string;
};
